<template>
  <span>
    {{ oiMixin_displayedObjectNumber }} ({{ agencyName }})
  </span>
</template>

<script>
import ObjectInternals from 'mixins/ObjectInternals';

export default {
  name: 'ObjectNumberAgency',
  mixins: [ObjectInternals],
  props: {
    objectDataInternal: {
      type: Object,
      default: () => {},
    },
    objectNumber: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    agencyName() {
      return this.objectDataInternal?.agencyName?.value || 'missing in ES';
    },
  },
};
</script>
